import keycloakApi from './keycloak-auth';

/**
 * Notification event type
 */
export interface NotificationEventType {
  id: number;
  code: string;
  name: string;
  description: string | null;
  isUmbrella: boolean;
}

/**
 * Notification preferences for a single email address
 */
export interface EmailNotificationPreferences {
  emailAddress: string;
  eventTypeIds: number[];
  recipientRole: 'to' | 'cc';
}

/**
 * Response for getting notification preferences
 */
export interface NotificationPreferencesResponse {
  partyId: string;
  partyRoleId: number;
  availableEventTypes: NotificationEventType[];
  emailPreferences: EmailNotificationPreferences[];
}

/**
 * Request to update notification preferences for an email
 */
export interface UpdateEmailPreferencesRequest {
  emailAddress: string;
  eventTypeIds: number[];
  recipientRole?: 'to' | 'cc';
}

const apiCall = async <T>(endpoint: string, options: RequestInit = {}): Promise<T> => {
  return keycloakApi.authenticatedApiCall<T>(endpoint, options);
};

/**
 * Get notification preferences for the current user's party
 */
export const getNotificationPreferences = async (): Promise<NotificationPreferencesResponse> => {
  return apiCall<NotificationPreferencesResponse>('/settings/notifications', {
    method: 'GET',
  });
};

/**
 * Update notification preferences for an email address
 */
export const updateEmailPreferences = async (
  data: UpdateEmailPreferencesRequest
): Promise<EmailNotificationPreferences> => {
  return apiCall<EmailNotificationPreferences>('/settings/notifications/email', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
};

/**
 * Remove all notification preferences for an email address
 */
export const removeEmailPreferences = async (
  emailAddress: string
): Promise<{ success: boolean; deletedCount: number }> => {
  return apiCall<{ success: boolean; deletedCount: number }>('/settings/notifications/email', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ emailAddress }),
  });
};
